import { StdResponse, request } from "@/global/config/request";
import { GlobalServer } from "@/global/interface/lib-device/global-server";


export function getGlobalServerDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-servers/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createGlobalServer(data: GlobalServer, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/global-servers`, data, {
        params: {
            ...params,
        }
    })
}

export function updateGlobalServer(id: number, data: GlobalServer, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/global-servers/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteGlobalServer(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/global-servers/${id}`, {
        params: {
            ...params,
        }
    })
}